import React, { Component } from 'react'
import ToutContentPositioned from './ToutContentPositioned'
import ToutContentAbsolute from './ToutContentAbsolute'

class ToutArea extends Component {
  render() {
    if (this.props.dataObject.area !== 'fill' && this.props.dataObject.content.type === 'text') {
      return (
        <div
          className={`tout-object ${this.props.dataObject.content.type === 'placeholder' ? 'placeholder-object' : ''} ${
            this.props.dataObject.classes ? this.props.dataObject.classes : ''
          } pos-r`}
          id={this.props.dataObject.id ? this.props.dataObject.id : null}
          style={{
            gridArea: this.props.dataObject.area
          }}
        >
          {this.props.dataObject.content.textlines.map((textLineObject, index) => (
            <ToutContentPositioned
              key={`${index}-${this.props.parentKey}`}
              data={textLineObject}
              asset={this.props.asset}
              type={'text'}
              onAction={this.props.onAction}
            />
          ))}
        </div>
      )
    } else if (this.props.dataObject.area !== 'fill' && this.props.dataObject.content.type !== 'text') {
      return (
        <div
          className={`tout-object ${this.props.dataObject.content.type === 'placeholder' ? 'placeholder-object' : ''} ${
            this.props.dataObject.classes ? this.props.dataObject.classes : ''
          } pos-r`}
          id={this.props.dataObject.id ? this.props.dataObject.id : null}
          style={{
            gridArea: this.props.dataObject.area,
            pointerEvents: 'auto'
          }}
        >
          <ToutContentPositioned
            data={this.props.dataObject.content}
            asset={this.props.asset}
            type={this.props.dataObject.content.type}
            onAction={this.props.onAction}
          />
        </div>
      )
    } else {
      return (
        <React.Fragment>
          <ToutContentAbsolute
            data={this.props.dataObject.content}
            id={this.props.dataObject.id ? this.props.dataObject.id : null}
            type={this.props.dataObject.content.type}
            asset={this.props.asset}
            onAction={this.props.onAction}
            isBanner={this.props.isBanner}
          />
        </React.Fragment>
      )
    }
  }
}

export default ToutArea
